import React, { useState } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { faCircle } from '@fortawesome/pro-regular-svg-icons/faCircle';
import {
  getOrganizationLogoUrls,
  getOrganizationMeta,
} from 'shared/utils/organization-display.utils';
import styles from './organization-selector.module.scss';

// The native input keeps arrow-key and screen-reader behavior; the circle on
// the right is only visual.
export const OrganizationCard = ({
  organization,
  isSelected,
  isLastUsed,
  disabled,
  onSelect,
  lang,
}) => {
  const { id, name } = organization;
  const meta = getOrganizationMeta(organization);
  const [logoIndex, setLogoIndex] = useState(0);
  const logoUrls = getOrganizationLogoUrls(organization);
  const logoUrl = logoUrls[logoIndex];

  return (
    <label
      className={classNames(styles.option, {
        [styles.optionSelected]: isSelected,
        [styles.optionDisabled]: disabled,
      })}>
      <input
        type="radio"
        className="sr-only"
        name="organization"
        value={id}
        checked={isSelected}
        disabled={disabled}
        onChange={() => onSelect(id)}
      />
      <span className={styles.optionBody}>
        {logoUrl && (
          <img
            className={styles.logo}
            src={logoUrl}
            alt=""
            onError={() => setLogoIndex(index => index + 1)}
          />
        )}
        <span className={styles.name}>{name}</span>
        {meta && <span className={styles.meta}>{meta}</span>}
        {isLastUsed && <span className={styles.chip}>{lang.LAST_USED}</span>}
      </span>
      <FontAwesomeIcon
        className={classNames(styles.indicator, { [styles.indicatorSelected]: isSelected })}
        icon={isSelected ? faCircleCheck : faCircle}
      />
    </label>
  );
};
